
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"62","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1766_20661)","stroke":"#fff","stroke-width":"3.875"}},[_c('rect',{attrs:{"x":"6.167","y":"10.333","width":"51.667","height":"41.333","rx":"12.917"}}),_c('path',{attrs:{"d":"M16.5 23.25l12.4 9.3a5.167 5.167 0 006.2 0l12.4-9.3","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1766_20661","x":"-3","y":"0","width":"70","height":"70","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"4"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1766_20661"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1766_20661","result":"shape"}})])])])
          )
        }
      }
    